export default __webpack_public_path__ + "static/media/notFound.4c33e24e.svg";